import { useRef } from "react";
import { Button, PopupModal, Input } from "shared";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import "./DeleteSuccessor.scss";
import { useDeleteSuccessor } from "hooks/successors";
import { VALIDATION_ENUM } from "enums";

interface DeleteSuccessorProps {
  isOpen: boolean;
  onClose: () => void;
  successorUuid: string;
}

const DeleteSuccessor: React.FC<DeleteSuccessorProps> = ({
  isOpen,
  onClose,
  successorUuid,
}) => {
  const formRef = useRef<any>(null);
  const deleteDoc = useDeleteSuccessor({
    onSuccess: () => {
      onClose();
    },
  });

  const validation = () =>
    Yup.object().shape({
      email: Yup.string()
        .email(VALIDATION_ENUM.WRONG_EMAIL)
        .required(VALIDATION_ENUM.REQUIRED)
        .trim()
        .matches(
          /^[a-zA-Z0-9_%+-]+([.][a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          VALIDATION_ENUM.WRONG_EMAIL
        ),
      password: Yup.string()
        .required(VALIDATION_ENUM.REQUIRED)
        .min(8, VALIDATION_ENUM.MIN_8),
    });

  const initialValues = {
    email: "",
    password: "",
    uuid: successorUuid,
  };

  const onSubmit = async (values: typeof initialValues) => {
    const { email, password, uuid } = values;
    await deleteDoc.mutate({ uuid, email, password });
  };

  return (
    <PopupModal isOpen={isOpen} onClose={onClose}>
      <h2 className="popup-modal__header popup-modal__header--mb-20">
        Usuwanie sukcesora
      </h2>
      <p className="popup-modal__subtitle">
        W celu usunięcia sukcesora, należy podać hasło do zakładki “Sukcesja”.
      </p>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => onSubmit(values)}
        validationSchema={validation()}
        innerRef={formRef}
      >
        {() => (
          <Form className="delete-doc__form">
            <Field
              type="text"
              id="email"
              name="email"
              label={"E-mail"}
              as={Input}
            />{" "}
            <Field
              type="password"
              id="password"
              name="password"
              label={"Hasło"}
              as={Input}
            />
            <div className="side-modal__buttons">
              <Button
                label="Anuluj"
                onClick={onClose}
                type="button"
                size="large"
                styleType="strokeBlack"
                className="button--wide"
              />
              <Button
                label="Potwierdź"
                type="submit"
                onClick={() => null}
                styleType="primary"
                size="large"
                className="button--wide"
              />
            </div>
          </Form>
        )}
      </Formik>
    </PopupModal>
  );
};

export default DeleteSuccessor;
